import { IconComponentsProps } from './types';

const FolderIcon = ({ fill = '#0000008C', ...props }: IconComponentsProps) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.3775 5.44141L10.9425 7.99891L11.3775 8.44141H21V20.4414H3V5.44141H8.3775ZM8.3775 3.94141H3C2.60218 3.94141 2.22064 4.09944 1.93934 4.38075C1.65804 4.66205 1.5 5.04358 1.5 5.44141V20.4414C1.5 20.8392 1.65804 21.2208 1.93934 21.5021C2.22064 21.7834 2.60218 21.9414 3 21.9414H21C21.3978 21.9414 21.7794 21.7834 22.0607 21.5021C22.342 21.2208 22.5 20.8392 22.5 20.4414V8.44141C22.5 8.04358 22.342 7.66205 22.0607 7.38075C21.7794 7.09944 21.3978 6.94141 21 6.94141H12L9.4425 4.38391C9.30296 4.24353 9.13701 4.13216 8.95423 4.05621C8.77144 3.98027 8.57543 3.94125 8.3775 3.94141Z"
      fill={fill}
    />
  </svg>
);

export default FolderIcon;
